export class SupplierPassengerCriteria {
  name: string;
  byAirlines: AirlinePassengerCriteria[];
  supPassMasterCriteriaId: number;
  supplier: string;
  isDeleted: boolean;


  // isByAirlines: boolean = false;

}

export class AirlinePassengerCriteria {
  airLinePassMasterCriteriaId: number;
  airlines: string[] = [];
  applyCriteria: boolean = false;
  isDeleted: boolean;
  showOptionalValues: boolean = false;

  title: boolean = false;
  firstName: boolean = false;
  lastName: boolean = false;
  gender: boolean = false;

  passport: boolean = false;
  passportIssueDate: boolean = false;
  passportExpiryDate: boolean = false;
  countryOfIssuance: boolean = false;

  dateOfBirth: boolean = false;
  nationality: boolean = false;
  age: boolean = false;
  frequentFlyerNo: boolean = false;

  email: boolean = false;
  phoneNo: boolean = false;

}

